import { ApolloClient, InMemoryCache, ApolloProvider as Provider } from '@apollo/client';
import { getEnvVariables } from 'helpers/getEnvVariables';

const { QUOTER_URL } = getEnvVariables()

export const client = new ApolloClient({
    uri: `${QUOTER_URL}/graphql`,
    cache: new InMemoryCache(),
    fetchOptions: {
        mode: 'no-cors',
    }
});

export function ApolloProvider({ children }) {
    return <Provider client={client}>{children}</Provider>;
}